// import { NotificationManager } from 'react-notifications'

export default function errorHandler(error, message) {
  console.error(error);
  // NotificationManager.error(message, 'Error', 3000)
}
